/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
export const BUBLIK_API_REDUCER_PATH = 'bublikApi';

export type API_REDUCER_PATH = typeof BUBLIK_API_REDUCER_PATH;
